export default "__VITE_ASSET__Bka2It3Q__"